/**
 * Route for `itet-install-to-event-time-rule`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { ItetInstallToEventTimeRulePage } from "../features/itet-install-to-event-time-rule/ItetInstallToEventTimeRulePage";

export const itetInstallToEventTimeRuleRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/itet-install-to-event-time-rule",
	component: ItetInstallToEventTimeRulePage,
});

export default itetInstallToEventTimeRuleRoute;
